module.exports = __webpack_public_path__ + "static/media/coronavirus.c7d908c9.jpeg";